// convention for constants is
// [App_Name]_[Action]
var TaxonomyConstants: ITaxonomyConstants = {
    TOGGLE_TAXONOMY_MODAL: 'TOGGLE_TAXONOMY_MODAL',
    TAXONOMY_SET_DATA: 'TAXONOMY_SET_DATA',
    TAXONOMY_CLASIFICATION_DATA: 'TAXONOMY_CLASIFICATION_DATA',
    TAXONOMY_VISIBLE_CLASIFICATION_DATA: 'TAXONOMY_VISIBLE_CLASIFICATION_DATA',
    TAXONOMY_CLASIFICATION_UPDATE_DATA: 'TAXONOMY_CLASIFICATION_UPDATE_DATA',
    TAXONOMY_BEGIN_EDIT: 'TAXONOMY_BEGIN_EDIT',
    TAXONOMY_BEGIN_FINISH: 'TAXONOMY_BEGIN_FINISH',
    TAXONOMY_UPDATE_EDIT: 'TAXONOMY_UPDATE_EDIT',
    TAXONOMY_FINISH_EDIT: 'TAXONOMY_FINISH_EDIT',
    TAXONOMY_FORM_TAGDISPLAYDATA: 'TAXONOMY_FORM_TAGDISPLAYDATA',
    TAXONOMY_FORM_ATTRIBUTEDATA: 'TAXONOMY_FORM_ATTRIBUTEDATA',
    TAXONOMY_FORM_FRIENDCLASSES: 'TAXONOMY_FORM_FRIENDCLASSES',
    TAXONOMY_EDIT: 'TAXONOMY_EDIT',
} as const;

export default TaxonomyConstants;
